import React from 'react';
import { TableItemActionsNew, Icons, PriceLabel } from 'components';
const columns = (navigate, getFunder, actionsList, currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },

  {
    title: 'نوع',
    field: 'type',
    align: 'center',
    filtering: false,
    render: (rd) => (rd.type == 'تنخواه گردان' ? 'تنخواه دار' : 'تنخواه گردان'),
  },
  {
    title: 'شناسه',
    field: 'id',
    align: 'center',
    filtering: false,
  },
  {
    title: 'نام',
    field: 'name',
    align: 'center',
    filtering: false,
  },
  {
    title: 'شماره حساب',
    field: 'accountNumber',
    align: 'center',
    filtering: false,
  },
  {
    title: 'نام ونام خانوادگی',
    field: 'fullName',
    align: 'center',
    filtering: false,
  },

  {
    title: `مانده (${currencyText})`,
    field: 'balance',
    align: 'center',
    filtering: false,
    render: (rowData) => <PriceLabel amount={rowData.balance} />,
  },
  {
    title: 'مانده اعتبار',
    field: 'remainCredit',
    align: 'center',
    filtering: false,
    render: (rowData) => <PriceLabel amount={rowData.remainCredit} />,
  },

  {
    title: 'مجموع (نقد و اعتبار)',
    field: 'remainUsable',
    align: 'center',
    filtering: false,
    render: (rowData) => <PriceLabel amount={rowData.remainUsable} />,
  },

  {
    title: 'وضعیت',
    field: 'status',
    align: 'center',
    filtering: false,
  },
  ...(actionsList['operationAllImprestFunderPage']
    ? [
        {
          title: 'عملیات',
          field: '',
          filtering: false,
          sorting: false,
          align: 'right',
          cellStyle: {
            width: '1%',
          },
          headerStyle: {
            width: '1%',
          },
          render: (rd) => (
            <TableItemActionsNew
              iconButton
              startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
              title=""
              otherMenus={[
                {
                  title: 'صورت حساب',
                  isShow: true,
                  onClick: async () => {
                    if (rd?.type == 'تنخواه گردان') {
                      const obj = await getFunder(rd.ssoid);
                      navigate(`/Funder/Transactions/${obj?.userId}?userName=${obj?.userName}`, {
                        state: rd,
                      });
                    } else {
                      navigate(`/Branch/Transactions/${rd.id}?imprest=true`, { state: rd });
                    }
                  },
                },
              ]}
            />
          ),
        },
      ]
    : []),
];

const columnsId = {
  docId: '1417',
  date: 'date',
  invoiceId: '1421',
  decreased: '1422',
  withdrawalDeposit: '1420',
  invoiceStatus: '1611',
  RRNId: '1426',
  typeOfTransaction: '1418', // '1596' استثنا برای این مورد که به شناسه تراکنش ارجاع داده می شود.
};

export { columns, columnsId };
